import React, { createContext, useState, useEffect } from 'react'
import LocalStorage from '../services/LocalStorage'

const TimezoneContext = createContext()
export default TimezoneContext

const browserTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone
const localStorageStateName = 'reporterTz'

export function TimezoneProvider(props) {

    const [reporterTz, setReporterTz] = useState(
        LocalStorage.getItem(localStorageStateName) || browserTimezone
    )

    useEffect(() => {
        LocalStorage.setItem(localStorageStateName, reporterTz)
    }, [reporterTz])

    return (
        <TimezoneContext.Provider
            value={{
                reporterTz,
                setReporterTz,
                browserTimezone,
            }}
            {...props}
        />
    )
}